export const basicBlueVariable = '#325194';
export const basicRedVariable = '#d14343';
export const basicDisabledGrey = '#787878';
export const basicGreenVariable  = 'green'